import Modal from "../Modal";
import { useState } from "react";
import { PartnerApi } from "../../../api/partner.api";
import InvoiceCanvas from "../../Invoice/InvoiceCanvas";
import { useAuthStore } from "../../../store/auth.store";
import { useTranslation } from "../../../hooks/useTranslation";

export default function LoanFilterModal({
  show,
  handleClose,
  filter,
  setFilter,
  selectedColumns,
  awailableColumns,
  toggleColumn,
  title = null,
}) {
  const { t } = useTranslation();
  const defaultTitle = t("common.filter");
  const user = useAuthStore((state) => state.user);
  return (
    <Modal title={title || defaultTitle} width="800px" show={show} handleClose={handleClose}>
      <div className="row">
        <div className="col-md-8">
          <div className="form-row mb-5">
            <label className="form-label fs-5 fw-semibold mb-3">
              {t("opportunities.createdFrom")}:
            </label>

            <div className="row">
              <div className="col-6">
                <input
                  className="form-control"
                  type="date"
                  defaultValue={filter.create_date_ge}
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      create_date_ge: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-6">
                <input
                  className="form-control"
                  type="date"
                  defaultValue={filter.create_date_le}
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      create_date_le: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
          <div className="form-row mb-5">
            <label className="form-label fs-5 fw-semibold mb-3">
              {t("loans.loanDate")}:
            </label>

            <div className="row">
              <div className="col-6">
                <input
                  className="form-control"
                  type="date"
                  defaultValue={filter.loan_from_ge}
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      loan_from_ge: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-6">
                <input
                  className="form-control"
                  type="date"
                  defaultValue={filter.loan_from_le}
                  onChange={(e) =>
                    setFilter({
                      ...filter,
                      loan_from_le: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="mb-10">
            <label className="form-label fs-5 fw-semibold mb-3">{t("common.data")}:</label>

            <div
              className="d-flex flex-column flex-wrap fw-semibold"
              data-kt-customer-table-filter="payment_type"
            >
              {Object.keys(awailableColumns).map((awailableColumnsKey) => (
                <label
                  key={awailableColumnsKey}
                  className="form-check form-check-sm form-check-custom form-check-solid mb-3 me-5"
                >
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={selectedColumns.includes(awailableColumnsKey)}
                    onChange={() => toggleColumn(awailableColumnsKey)}
                  />
                  <span className="form-check-label text-gray-600">
                    {awailableColumns[awailableColumnsKey]}
                  </span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="px-7 py-5">
        <div className="d-flex justify-content-end d-none">
          <button
            type="reset"
            className="btn btn-light btn-active-light-primary me-2"
            data-kt-menu-dismiss="true"
            data-kt-customer-table-filter="reset"
          >
            {t("common.reset")}
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            data-kt-menu-dismiss="true"
            data-kt-customer-table-filter="filter"
          >
            {t("common.save")}
          </button>
        </div>
      </div>
    </Modal>
  );
}
